


import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
}

function ProfileFooter({ color }: Props): ReactElement {

    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.2998 10.9C14.5089 10.9 16.2998 9.10916 16.2998 6.90002C16.2998 4.69089 14.5089 2.90002 12.2998 2.90002C10.0907 2.90002 8.2998 4.69089 8.2998 6.90002C8.2998 9.10916 10.0907 10.9 12.2998 10.9Z" fill={color ? color : ""} stroke={color ? color : "#155a9e"} strokeWidth="1.5"/>
        <path d="M12.2998 21.8998C16.1658 21.8998 19.2998 20.1089 19.2998 17.8998C19.2998 15.6906 16.1658 13.8998 12.2998 13.8998C8.43381 13.8998 5.2998 15.6906 5.2998 17.8998C5.2998 20.1089 8.43381 21.8998 12.2998 21.8998Z" fill={color ? color : ""} stroke={color ? color : "#424242"} strokeWidth="1.5"/>
        </svg>
    );
}

export default ProfileFooter;